import SiteHeader from './custom-blocks/site-header/site-header.js';
import HeroSlider from './custom-blocks/hero-slider/hero-slider.js';
import SiteFooter from './custom-blocks/site-footer/site-footer.js';
import PageHeroBand from './custom-blocks/page-hero-band/page-hero-band.js';
import ContinuousSlider from './custom-blocks/full-width-slider/full-width-slider.js';

SiteHeader.onReady();
HeroSlider.onReady();
SiteFooter.onReady();
PageHeroBand.onReady();
ContinuousSlider.onReady();

// Tab switching for the capability-tabs / dev-support-tabs blocks.
function initServiceTabs() {
	document.querySelectorAll('[data-svc-tabs]').forEach(function (wrap) {
		var tabs = wrap.querySelectorAll('[data-svc-tab]');
		var panels = wrap.querySelectorAll('[data-svc-panel]');
		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				var idx = tab.getAttribute('data-svc-tab');
				tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
				panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-svc-panel') === idx); });
			});
		});
	});
}
if (document.readyState !== 'loading') {
	initServiceTabs();
} else {
	document.addEventListener('DOMContentLoaded', initServiceTabs);
}
